import {Component, OnInit} from '@angular/core';
import {AdminService} from "../../service/admin.service";
import {AlertController, LoadingController, ModalController, ToastController} from "@ionic/angular";
import {AuthService} from "../../service/auth.service";

@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.page.html',
  styleUrls: ['./user-add.page.scss'],
})
export class UserAddPage implements OnInit {
  res: boolean;
  show_form: Boolean;
  documents: any;
  secondSurName: any;
  firstLastName: any;
  secondName: any;
  firstName: any;
  loading: any;
  userTypes: any[];
  document: any;
  phone: any;
  showPassword= false;
  password: any;

  constructor(public alertController: AlertController,
              public loadingController: LoadingController,
              private adminService: AdminService,
              private authService: AuthService,
              public toastController: ToastController,
              public modalController: ModalController,
  ) {
  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this. getTypeIdentificationId();
    this.getTypeUser();
  }

  validateOnlyLetters() {
    if (this.firstName) {
      this.firstName = String(this.firstName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondName) {
      this.secondName = String(this.secondName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.firstLastName) {
      this.firstLastName = String(this.firstLastName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondSurName) {
      this.secondSurName = String(this.secondSurName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
  }

  async signup(data) {
    await this.loading.present();
    this.authService.createUser(data).subscribe(response => {
      console.log('response of create user', response)
      this.presentToast("Cuenta creada con éxito.");
      this.show_form = false;
      this.loading.dismiss();
      this.close();
    }, error => {
      console.warn('Error Crear Usuario', error);
      this.presentToast('Por favor verifique sus datos, algunos campos contienen información no valida');
      this.loading.dismiss();
    })

  }

  async close(data?: any) {
    await this.modalController.dismiss(data);
  }

  getTypeIdentificationId() {
    this.loading.present();
    this.adminService. getTypeIdentificationId().subscribe((res: any) => {
      this.documents = res;
      this.loading.dismiss();
    });
  }

  getTypeUser() {
    this.loading.present();
    this.adminService.getUserTypes().subscribe((res: any) => {
      this.userTypes = res;
      this.loading.dismiss();
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  validateOnlyNumbers() {
    if (this.document) {
      this.document = this.document.replace(/\D/g, '');
      this.document = this.document.substring(0, 20);

    }
    if (this.phone) {
      this.phone = this.phone.replace(/\D/g, '');
      this.phone = this.phone.substring(0, 11);
    }

  }
}
